// GETTERS
// export const GET_VITAL = 'vital/GET_VITAL';
// export const GET_VITAL_LIST = 'vital/GET_VITAL_LIST';


// MUTATORS
// export const MUTATE_LIST_VITAL = 'vital/MUTATE_LIST_VITAL';


// ACTIONS
// export const ACTION_LIST_VITALS = 'vital/ACTION_LIST_VITALS';
export const ACTION_ADD = 'vital/ACTION_ADD';
export const ACTION_DELETE = 'vital/ACTION_DELETE';
export const ACTION_UPDATE = 'vital/ACTION_UPDATE';
// export const ACTION_GET_VITAL = 'vital/ACTION_GET_VITAL';



// WEBPACK FOOTER //
// ./src/store/constants/vital.js